import { useEffect, useRef, useState } from 'react';

/**
 * Like RevealLeft, but slides up from below instead of in from the
 * left. Used for the giant "BOTIFY" wordmark in the footer.
 */
export default function RevealUp({ children, className = '' }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.15 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={`reveal-up ${visible ? 'is-visible' : ''} ${className}`}>
      {children}
    </div>
  );
}